export enum DividendStatusType {
  E = 0,
  V = 1,
  A = 2,
  R = 3,
  K = 4,
}
